import React, { Component } from "react";
import { ButtonToolbar, Table, Grid } from 'react-bootstrap';

import { PaginationBuilder } from '../../PaginationBuilder';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchHelper } from '../../helpers/SearchHelper';
import { LoadingSpinner } from '../../LoadingSpinner';
import { ComparisonHelper } from '../../helpers/ComparisonHelper';
import { TableButton } from '../../TableButton';
import { SelectOptionsHelper } from '../../helpers/SelectOptionsHelper';


export class ActivePOIs extends Component {
    getPointOfInterestTypeLabel(value) {
        const pointOfInterestType = SelectOptionsHelper.PointOfInterestTypes.find(x => x.value === value);
        if(undefined === pointOfInterestType) {
            return SelectOptionsHelper.PointOfInterestTypes.find(x => x.value === 0).label
        }

        return pointOfInterestType.label;
    }
    
    // -----------------------

    sortPOIs(a, b) {
        let aName = a.name;
        let bName = b.name;

        if ("object" === typeof aName) {
            aName = undefined !== aName.left ? aName.left : aName.right;
        }

        if ("object" === typeof bName) {
            bName = undefined !== bName.left ? bName.left : bName.right;
        }

        return aName !== bName ? aName < bName ? -1 : 1 : 0;
    }

    parseArray(array) {
        if (!Array.isArray(array)) {
            return undefined;
        }

        return array.sort().join(",");
    }

    // -----------------------

    renderLoading(isLoading) {
        if (isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderType(value) {
        if (value === undefined) {
            return null;
        }

        return this.getPointOfInterestTypeLabel(value);
    }

    renderWorkingHours(value) {
        if (value === undefined) {
            return null;
        }

        return (
            value.map((wh, i) => <li key={`poi-wh-${i}`}>{wh}</li>)
        );
    }

    renderContacts(value) {
        if (value === undefined) {
            return null;
        }

        return (
            value.map((ct, i) => <li key={`poi-ct-${i}`}>{ct}</li>)
        );
    }

    render() {
        const { pois, isLoading, currentPage, elementsPerPage, isComparing, filter } = this.props;

        let poisFiltered;
        if (isComparing) {
            const { draftPOIs } = this.props;
            poisFiltered = SearchHelper.search({
                filter: filter,
                data: ComparisonHelper.compare(
                    pois,
                    draftPOIs || [],
                    {
                        match: [{ left: "name", right: "name" }],
                        fields: [{ left: "name", right: "name" }, { left: "description", right: "description" }, { left: "coordX", right: "coordX" }, { left: "coordY", right: "coordY" }, { left: "type", right: "type" }, { left: "workingHours", right: "workingHours", leftParser: (a) => this.parseArray(a), rightParser: (a) => this.parseArray(a) }, { left: "contacts", right: "contacts", leftParser: (a) => this.parseArray(a), rightParser: (a) => this.parseArray(a) }]
                    }),
                fields: ["name", "name.left", "name.right", "description", "description.left", "description.right", "coordX", "coordX.left", "coordX.right", "coordY", "coordY.left", "coordY.right", "type", "type.left", "type.right", "workingHours", "workingHours.left", "workingHours.right", "contacts", "contacts.left", "contacts.right"],
                callbackComparison: [
                    { "type": (t) => this.getPointOfInterestTypeLabel(t) },
                    { "type.left": (t) => this.getPointOfInterestTypeLabel(t) },
                    { "type.right": (t) => this.getPointOfInterestTypeLabel(t) }
                ]
            });
        }
        else {
            poisFiltered = SearchHelper.search({
                filter: filter,
                data: pois,
                fields: ["name", "description", "type", "coordX", "coordY"],
                callbackComparison: [
                    { "type": (t) => this.getPointOfInterestTypeLabel(t) }
                ]
            });
        }

        const totalFilteredPages = PaginationHelper.getTotalPages(poisFiltered.length, elementsPerPage);
        let activePage = totalFilteredPages < currentPage ? totalFilteredPages : currentPage;

        const poisToRender = poisFiltered.sort((a, b) => this.sortPOIs(a, b))
            .slice((activePage - 1) * elementsPerPage, activePage * elementsPerPage);

        return (
            <Grid fluid className="table-small-screens">
                <div className="table-loading">
                    <Table responsive striped hover>
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Descrição</th>
                                <th>Tipo</th>
                                <th>Latitude</th>
                                <th>Longitude</th>
                                <th>Horários de Funcionamento</th>
                                <th>Contactos</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody className={isLoading ? "overlay" : ""}>
                            {
                                poisToRender.map((poi, idx) =>
                                    <tr key={`poi-${idx}`} className={ComparisonHelper.getRowClass(poi.name)}>
                                        <td>{ComparisonHelper.renderProperty(poi.name)}</td>
                                        <td>{ComparisonHelper.renderProperty(poi.description)}</td>
                                        <td>{ComparisonHelper.renderProperty(poi.type, (value) => this.renderType(value))}</td>
                                        <td>{ComparisonHelper.renderProperty(poi.coordX)}</td>
                                        <td>{ComparisonHelper.renderProperty(poi.coordY)}</td>
                                        <td>{ComparisonHelper.renderProperty(poi.workingHours, (value) => this.renderWorkingHours(value))}</td>
                                        <td>{ComparisonHelper.renderProperty(poi.contacts, (value) => this.renderContacts(value))}</td>
                                        <td>
                                            <ButtonToolbar className="pull-right">
                                                <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.props.onEditClick(poi)} />
                                                <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.props.onDeleteClick(poi)} />
                                            </ButtonToolbar>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table>

                    <PaginationBuilder
                        currentPage={activePage}
                        elementsPerPage={elementsPerPage}
                        dataLength={poisFiltered.length}
                        onChangePage={(a) => this.props.onChangePage(a)}
                        onChangeElementsPerPage={(a) => this.props.onChangeElementsPerPage(a)} />

                    {this.renderLoading(isLoading)}
                </div>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/pointsOfInterest/ActivePOIsList.js